export default __webpack_public_path__ + "659c9e08a5900992b06914cdc7809edb.png";